import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useURLSearchQuery } from 'modules/Core/Hooks';
import { Button, Icon } from 'modules/Core/Common';
import { deletePropsFromQueryString } from 'modules/Utils';
import * as S from './BackToListButton.styles';

export const BackToListButton = ({ path, noReplace }) => {
  const navigate = useNavigate();
  const { queryParams } = useURLSearchQuery();

  const handleBackToList = () => {
    const pathHasQuestionMark = path?.includes('?');
    const parsedQueryParams = queryParams
      ? `${pathHasQuestionMark ? '' : '?'}${queryParams}`
      : '';
    const newLink = `${path}${parsedQueryParams}`;

    if (noReplace) {
      return navigate(newLink);
    }

    const newQueryParams = deletePropsFromQueryString(queryParams, [
      'page',
      'paginates_per',
    ])
      .replace('page_submission', 'page')
      .replace('paginates_per_submission', 'paginates_per')
      .replace('//', '/');

    const newLinkReplaced = `${path}${queryParams ? `${newQueryParams}` : ''}`;

    return navigate(newLinkReplaced);
  };

  return (
    <S.Container>
      <Button
        large
        type="button"
        data-test="submit"
        transparent
        onClick={handleBackToList}
      >
        <Icon name="chevron-left" />
        {i18n.t('commons.buttons.go-to-submissions')}
      </Button>
    </S.Container>
  );
};

BackToListButton.propTypes = {
  noReplace: PropTypes.bool,
  path: PropTypes.string,
};
